<template>
  <div class="review-and-submit">
    <div class="header-container">
      <h2>Review and submit</h2>
      <!-- review and submit key/legend -->
      <div v-if="infoKey" class="key-item">
        <img src="/assets/public/images/icon_review_and_submit_info.svg" />
        <span>Important fields are indicated by an information icon</span>
      </div>
      <div v-if="updateKey" class="key-item">
        <img src="/assets/public/images/icon_review_and_submit_update.svg" />
        <span>Updated fields are indicated by an updated icon</span>
      </div>
    </div>
    <!-- This is a slot for other items -->
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'ReviewAndSubmitComponent',
  props: {
    infoKey: {
      type: Boolean,
      default: true,
    },
    updateKey: {
      type: Boolean,
      default: true,
    },
  },
  // other component options go here
};
</script>

<style lang="scss" scoped></style>
